"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _marked = _interopRequireDefault(require("marked"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var _escapeHtml = _interopRequireDefault(require("escape-html"));

var _rehype = _interopRequireDefault(require("rehype"));

var _highlight = _interopRequireDefault(require("../utils/highlight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const renderer = new _marked.default.Renderer();

renderer.heading = function heading(...args) {
  return _marked.default.Renderer.prototype.heading.apply(this, args).replace(/^(<h[1-3] [^>]+>)(.+)(<\/h[1-3]>)/, (match, p1, p2, p3) => `${p1}
          <a class="anchor" href="#${p2.toLowerCase() // Strip HTML tags
  .replace(/(<([^>]+)>)/g, '').replace(/[^a-z0-9]+/g, '-')}">
            <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
              <path fill-rule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path>
            </svg>
          </a>
        ${p2}${p3}`);
};

class Markdown extends React.Component {
  render() {
    let html = (0, _marked.default)(this.props.source, {
      renderer,
      gfm: true,
      silent: true,
      highlight: (code, lang) => {
        try {
          const nodes = (0, _highlight.default)(code, lang);
          return (0, _rehype.default)().stringify({
            type: 'root',
            children: nodes
          }).toString();
        } catch (err) {
          if (/Unknown language/.test(err.message)) {
            return (0, _escapeHtml.default)(code);
          }

          throw err;
        }
      }
    });
    html = (0, _sanitizeHtml.default)(html, require('../configs/santize-config.json'));
    return React.createElement("div", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: html
      },
      className: this.props.className
    });
  }

}

exports.default = Markdown;
//# sourceMappingURL=Markdown.js.map